module.exports = __webpack_public_path__ + "static/year2014-15109ac8cfc6ce5cb6eadb87982e2143.jpg";